import { cn } from "@/lib/utils";

const TONE = { green: "text-os-green", amber: "text-os-amber", red: "text-os-red", muted: "text-os-ink-3" };

export const StateWord = ({ tone, className, children }) => (
  <span data-testid="state-word" data-tone={tone} className={cn("whitespace-nowrap text-[0.6875rem] font-semibold uppercase tracking-[0.08em]", TONE[tone], className)}>
    {children}
  </span>
);

export const WaitingChip = ({ className, children }) => (
  <p data-testid="waiting-chip" className={cn("rounded-chip border border-os-bronze border-b-os-bronze-strong bg-os-gold-tint px-3 py-2.5 text-[0.875rem] leading-[1.45] text-os-ink", className)}>
    {children}
  </p>
);
